import { useEffect, useState } from "react";
import { productionGateway } from "../production-gateway";
import type { TerminalBootstrap } from "../models";

export type TemporaryTakeoverDialogProps = { context: TerminalBootstrap; notify: (message: string, tone?: "success" | "error") => void; onClose: () => void; onCompleted: () => Promise<void> };

export function useTemporaryTakeoverWorkspace({ context, notify, onClose, onCompleted }: TemporaryTakeoverDialogProps) {
  const [supervisors, setSupervisors] = useState<Array<{ id: string; name: string }>>([]);
  const [supervisorId, setSupervisorId] = useState("");
  const [supervisorPin, setSupervisorPin] = useState("");
  const [approvalToken, setApprovalToken] = useState("");
  const [operators, setOperators] = useState<Array<{ id: string; name: string }>>([]);
  const [operatorId, setOperatorId] = useState("");
  const [operatorPin, setOperatorPin] = useState("");
  const [saving, setSaving] = useState(false);
  const [loadingOptions, setLoadingOptions] = useState(true);
  const [message, setMessage] = useState("Vardiya amirleri yükleniyor…");
  useEffect(() => {
    void productionGateway.terminalSupervisors(context.terminal.terminalCode).then((items) => {
      setSupervisors(items); setSupervisorId(items[0]?.id ?? "");
      setMessage(items.length ? "Vardiya amirini seçip kendi PIN’ini girmesini isteyin." : "Aktif vardiya amiri bulunamadı. Sistem yöneticisine başvurun.");
    }).catch((error) => {
      const errorMessage = error instanceof Error ? error.message : "Vardiya amirleri alınamadı.";
      setMessage(errorMessage); notify(errorMessage);
    }).finally(() => setLoadingOptions(false));
  }, [context.terminal.terminalCode, notify]);
  const approve = async () => {
    const supervisor = supervisors.find((item) => item.id === supervisorId);
    if (!supervisor || supervisorPin.length !== 4) return;
    setSaving(true);
    try {
      const approval = await productionGateway.approveCriticalAction({ supervisorId: supervisor.id, supervisorName: supervisor.name, pin: supervisorPin, actionScope: "UNASSIGNED_TAKEOVER", targetRef: context.terminal.id });
      const items = await productionGateway.temporaryTakeoverOperators(context.terminal.terminalCode, approval.approvalToken);
      setApprovalToken(approval.approvalToken); setOperators(items); setOperatorId(items[0]?.id ?? ""); setSupervisorPin("");
      setMessage(items.length ? "Amir onayı alındı. Devralacak operatörü seçin." : "Geçici devralma için uygun aktif operatör bulunamadı.");
    } catch (error) { const errorMessage = error instanceof Error ? error.message : "Amir onayı doğrulanamadı."; setMessage(errorMessage); notify(errorMessage); }
    finally { setSaving(false); }
  };
  const takeOver = async () => {
    if (!approvalToken || !operatorId || operatorPin.length !== 4) return;
    setSaving(true);
    try {
      await productionGateway.temporaryTakeover(context.terminal.terminalCode, operatorId, operatorPin, approvalToken);
      notify("Geçici operatör devralması açıldı."); onClose(); await onCompleted();
    } catch (error) { setOperatorPin(""); const errorMessage = error instanceof Error ? error.message : "Geçici devralma açılamadı."; setMessage(errorMessage); notify(errorMessage); }
    finally { setSaving(false); }
  };
  return { supervisors, supervisorId, setSupervisorId, supervisorPin, setSupervisorPin, approvalToken, operators, operatorId, setOperatorId, operatorPin, setOperatorPin, saving, loadingOptions, message, approve, takeOver };
}
